// Presentación de las métricas de mascotas protegidas (spec 030). Funciones
// puras: los textos y la forma de los datos del gráfico, sin cálculo de negocio.

const MODEL_SHORT_LABELS = {
  one_per_user: 'Uno a uno',
  all_users: 'Todos × límite',
  pool: 'Bolsa'
};

/**
 * Etiqueta corta del modelo de potencial.
 * @param {string|null} model
 * @returns {string}
 */
export function modelLabel(model) {
  if (!model) return 'Fuera de vigencia';
  return MODEL_SHORT_LABELS[model] || model;
}

export const FLAG_LABELS = {
  unlimited_limit_assumed_one: 'Sin límite: supuesto 1',
  pool_exceeded: 'Bolsa superada',
  quota_anomalous: 'Cupo anómalo',
  no_users_with_access: 'Sin usuarios con acceso',
  out_of_scope: 'Fuera de vigencia'
};

/**
 * @param {string} flag
 * @returns {string}
 */
export function flagLabel(flag) {
  return FLAG_LABELS[flag] || flag;
}

/**
 * Primer mes de la serie para un rango.
 * @param {string} currentPeriod - Mes en curso, YYYY-MM.
 * @param {number|'all'} range - 12, 24 o 'all'.
 * @returns {string|undefined} YYYY-MM, o undefined para "todo" (el backend lo acota).
 */
export function rangeFrom(currentPeriod, range) {
  if (range === 'all') return '2000-01';
  const [year, month] = currentPeriod.split('-').map(Number);
  const index = year * 12 + (month - 1) - (Number(range) - 1);
  return `${Math.floor(index / 12)}-${String((index % 12) + 1).padStart(2, '0')}`;
}

/**
 * Período actual (YYYY-MM) en hora local del navegador.
 * @param {Date} [now]
 */
export function currentPeriodOf(now = new Date()) {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

/**
 * Datasets del gráfico. Chart.js 2 no estiliza por segmento, así que lo
 * reconstruido y lo registrado (foto o en vivo) van en datasets separados que
 * se tocan en el mes de corte.
 * @param {Array<{period: string, activePets: number, potentialPets: number|null, source: string}>} series
 * @returns {{ months: Array<{month: string, partial: boolean}>, reconstructed: Array<number|null>, recorded: Array<number|null>, potential: Array<number|null> }}
 */
export function buildTrendSeries(series) {
  const lastIndex = series.length - 1;
  const firstRecorded = series.findIndex((p) => p.source !== 'reconstructed');
  const reconstructed = series.map((p, i) => {
    if (p.source === 'reconstructed') return p.activePets;
    return i === firstRecorded ? p.activePets : null;
  });
  const recorded = series.map((p) => (p.source === 'reconstructed' ? null : p.activePets));
  return {
    months: series.map((p, i) => ({ month: p.period, partial: i === lastIndex })),
    reconstructed,
    recorded,
    potential: series.map((p) => (p.potentialPets == null ? null : p.potentialPets))
  };
}

/**
 * Formato de miles en es-CL.
 * @param {number|null} n
 */
export function formatInt(n) {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(n);
}
